export default {

  setCookie(name, value, exdays){
    var Days = exdays; //默认将被保存 1 天
    var exp  = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = name + "="+ escape(value) +";expires="+ exp.toGMTString();
  },

  getCookie(name){
    var arr = document.cookie.match(new RegExp("(^| )"+name+"=([^;]*)(;|$)"));
    if(arr != null){
      return unescape(arr[2])
    }else{
      return null
    }
  },

  clearCookie(name){
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval=this.getCookie(name);
    if(cval!=null) document.cookie=name +"="+cval+";expires="+exp.toGMTString();
  }

}

